import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';
import {Editor} from "./editor";
import {Control} from './panda';
import {EditorControls} from "./controls";
import {PlayerAnimations} from "./player/animation";
import {PlayerEvents} from "./player/event";
import {PlayerTwin} from "./player/twin";
import {Object3D, Scene, Vector2,AnimationMixer} from "three";
import {EventType} from "./enums";
import {ViewEffectComposer} from "./effect";
import {VSMShadowMap} from "three/src/constants";

export namespace MyPlayer {
  export let globalPlayer: AppPlayer;
}

function Player(el:HTMLElement, editor: Editor) {

  const signals = editor.signals;

  const dom = document.createElement('div');
  dom.id = 'panda-player';
  dom.style.position = 'absolute';
  dom.style.display = 'none';
  //
  const player = new AppPlayer(editor);
  dom.appendChild(player.dom);

  window.addEventListener('resize', function () {
    player.setSize(dom.clientWidth, dom.clientHeight);
  });

  signals.windowResize.add(function () {
    player.setSize(dom.clientWidth, dom.clientHeight);

  });

  signals.startPlayer.add(function () {
    dom.style.display = 'block';
    player.load(editor.toJSON());
    if(player.effectComposer){
      player.effectComposer.effectComposer.dispose()
    }
    // 后期处理
    player.effectComposer = new ViewEffectComposer(player.scene,player.camera, el)
    player.effectComposer.setEffectComposer(player.renderer)

    MyPlayer.globalPlayer = player

    player.setSize(dom.clientWidth, dom.clientHeight);
    player.play();
  });

  signals.stopPlayer.add(function () {
    dom.style.display = 'none';
    player.stop();
    player.dispose();

  });

  return dom;

}


export class AppPlayer {
  editor: Editor
  renderer: THREE.WebGLRenderer;
  loader = new THREE.ObjectLoader();
  camera?: THREE.Camera;
  scene: THREE.Scene;
  dom: HTMLElement;
  width: number;
  height: number;
  clock = new THREE.Clock();
  mixer: AnimationMixer

  time?: number;
  startTime?: number;
  prevTime?: number;
  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2();
  // 全局事件
  events: any = {
    start: [],  // 运行场景
    stop: [],   // 停止场景
    keydown: [],
    keyup: [],
    update: []  // 场景更新
  };

  animation: PlayerAnimations;
  event: PlayerEvents;
  twin: PlayerTwin;

  controls?:EditorControls;
  onUpPosition = new THREE.Vector2();
  onDownPosition = new THREE.Vector2();
  onPosition = new THREE.Vector2();
  isMouseOverModel = false;
  mouseOverModel : Object3D;

  effectComposer: ViewEffectComposer

  constructor(editor: Editor) {
    this.editor = editor
    this.renderer = new THREE.WebGLRenderer({ antialias: true});
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.VSMShadowMap

    const dom = document.createElement('div');
    dom.appendChild(this.renderer.domElement);
    this.dom = dom;
  }
  setScene(scene: THREE.Scene) {
    this.scene = scene;
  };
  setCamera(value: THREE.Camera) {
    this.camera = value;
    if (this.camera instanceof THREE.PerspectiveCamera) {
      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();
    }
  }

  setSize(width: number, height: number) {

    this.width = width;
    this.height = height;

    if (this.camera instanceof THREE.PerspectiveCamera) {

      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();

    }
    this.renderer.setSize(width, height);
  }

  dispatch(array: any, event: any) {
    for (let i = 0, l = array.length; i < l; i++) {
      array[i](event);
    }
  }

  animate() {
    // 物体看向摄像头
    this.editor.objLookCamera(this.scene, this.camera)
    // 模型自带动画
  
    var delta = this.clock.getDelta();
		this.mixer.update( delta );

    this.time = performance.now();
    try {
      if (this.time !== undefined && this.prevTime !== undefined && this.startTime !== undefined)
        this.dispatch(this.events.update, { time: this.time - this.startTime, delta: this.time - this.prevTime });
    } catch (e: any) {
      console.error((e.message || e), (e.stack || ''));
    }
    this.controls.controls.update()
    // 是后期处理时使用的
    this.effectComposer.effectComposer.render();
    //this.renderer.render(this.scene, this.camera);
    this.prevTime = this.time;
    TWEEN.update();
  }

  play() {
    // 物体发光
    this.editor.objOutline(this.scene,this.effectComposer)
    // 物体线框
    this.editor.objEdge(this.scene)

    this.startTime = this.prevTime = performance.now();

    document.addEventListener('keydown', this.onKeyDown.bind(this));
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    this.dom.addEventListener( 'mousedown', this.onMouseDown.bind(this), false );   //鼠标左右中键点击事件
    this.dom.addEventListener( 'dblclick', this.onDoubleClick.bind(this), false );	 // 鼠标左键双击
    this.dom.addEventListener( 'mousemove', this.onMousemove.bind(this), false ); //鼠标移动事件

    this.dispatch(this.events.start, arguments);
    this.renderer.setAnimationLoop(this.animate.bind(this));
  };

  stop() {
    document.removeEventListener('keydown', this.onKeyDown.bind(this));
    document.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.dom.removeEventListener('mousedown', this.onMouseDown.bind(this));
    this.dom.removeEventListener('dblclick', this.onDoubleClick.bind(this));
    this.dom.removeEventListener('mousemove', this.onMousemove.bind(this));

    this.dispatch(this.events.stop, arguments);

    this.renderer.setAnimationLoop(null);

  }
  //
  getMousePosition( dom:HTMLElement, x:number, y:number ) {
    let rect = dom.getBoundingClientRect();
    return [ ( x - rect.left ) / rect.width, ( y - rect.top ) / rect.height ];
  }

  render(time: number) {
    this.dispatch(this.events.update, { time: time * 1000, delta: 0 /* TODO */ });
    this.effectComposer.effectComposer.render();
  }

  dispose() {
    this.renderer.dispose();
    this.camera = undefined;
    // 清除后期处理
    if (this.effectComposer){
      this.effectComposer.effectComposer.dispose()
    }
    // 清除控制器
    if(this.controls){
      this.controls.controls.dispose();
    }
    // 停止所有模型动画
    this.mixer.stopAllAction()
    this.mixer.update(0)

    // 关闭通信
    if (this.twin){
      this.twin.close()
    }
  }

  //
  onKeyDown(event: KeyboardEvent) {
    this.dispatch(this.events.keydown, event);
  }

  onKeyUp(event: KeyboardEvent) {
    this.dispatch(this.events.keyup, event);
  }
  onPointerDown(event: PointerEvent) {
    this.dispatch(this.events.pointerdown, event);
  }

  onPointerUp(event: PointerEvent) {
    this.dispatch(this.events.pointerup, event);
  }

  onPointerMove(event: PointerEvent) {
    this.dispatch(this.events.pointermove, event);
  }

  onMouseDown(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    var array = this.getMousePosition( this.dom, event.clientX, event.clientY );
    this.onPosition.fromArray( array );

    let intersects = this.getIntersects( this.onPosition, this.scene.children );
    if ( intersects.length > 0 ) {
      let object = intersects[ 0 ].object;
      while (object.parent.type !== "Scene") {
        object = object.parent;
      }
      if (event.button === 0) {
        this.event.runObjectEvent(object, EventType.ClickL)
      } else if (event.button === 2) {
        this.event.runObjectEvent(object, EventType.ClickR)
      }
    }
  }

  onDoubleClick(event: MouseEvent) {
    var array = this.getMousePosition( this.dom, event.clientX, event.clientY );
    this.onPosition.fromArray( array );
    var intersects = this.getIntersects( this.onPosition, this.scene.children );
    if ( intersects.length > 0 ) {
      this.event.runObjectEvent(intersects[ 0 ].object, EventType.DbClick)
    }
  }

  onMousemove(event: MouseEvent) {
    var array = this.getMousePosition( this.dom, event.clientX, event.clientY );
    this.onPosition.fromArray( array );

    var intersects = this.getIntersects( this.onPosition, this.scene.children );
    if ( intersects.length > 0 ) {
      if (!this.isMouseOverModel ) {
        this.isMouseOverModel = true;
        this.mouseOverModel = intersects[ 0 ].object
        this.event.runObjectEvent(intersects[ 0 ].object, EventType.MoveIn)
      }
    }else {
      if (this.isMouseOverModel) {
        // 鼠标移出模型
        this.isMouseOverModel = false;
        // 执行鼠标移出逻辑...
        this.event.runObjectEvent(this.mouseOverModel, EventType.MoveOut)
      }
    }
  }
  //拾取
  getIntersects( point:Vector2, objects:Object3D[] ) {
    this.mouse.set( ( point.x * 2 ) - 1, - ( point.y * 2 ) + 1 );
    this.raycaster.setFromCamera( this.mouse, this.camera );
    return this.raycaster.intersectObjects( objects );
  }


  load(json: any) {
    let options = json.options;

    // 加载画布
    this.setScene(this.loader.parse(json.scene) as THREE.Scene);
    this.setCamera(this.loader.parse(json.camera) as THREE.Camera);

    // 控制器
    this.controls = new EditorControls( this.camera, this.dom );
    if(options.control!==undefined&&options.control!==null){
      let params=options.control as Control;
      this.controls.setOptions(params)
    }

    this.events = {
      start: [],
      stop: [],
      keydown: [],
      keyup: [],
      update: []
    };

    let scriptWrapParams = 'player,renderer,scene,camera';
    let scriptWrapResultObj: any = {};

    for (var eventKey in this.events) {
      scriptWrapParams += ',' + eventKey;
      scriptWrapResultObj[eventKey] = eventKey;
    }

    let scriptWrapResult = JSON.stringify(scriptWrapResultObj).replace(/\"/g, '');
    for (let uuid in json.scripts) {
      let object = this.scene?.getObjectByProperty('uuid', uuid);
      if (object === undefined) {
        console.warn('APP.Player: Script without object.', uuid);
        continue;
      }
      let scripts = json.scripts[uuid];
      for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i];
        let functions = (new Function(scriptWrapParams, script.source + '\nreturn ' + scriptWrapResult + ';').bind(object))(this, this.renderer,this.scene, this.camera);
        for (let name in functions) {
          if (functions[name] === undefined) continue;
          if (this.events[name] === undefined) {
            console.warn('APP.Player: Event type not supported (', name, ')');
            continue;
          }
          this.events[name].push(functions[name].bind(object));
        }
      }
    }

    // 查看导入的模型是否有动画，有动画进行播放
    // 模型为Group 是否需要遍历每个模型设置动画播放
    // if (obj instanceof THREE.Group)
    // if (obj instanceof THREE.Mesh)
    // 播放模型自带动画
    this.mixer = new THREE.AnimationMixer(this.scene);
    this.scene.traverse(object=>{
      if(object.animations && object.animations.length>0){
				for (let i = 0; i < object.animations.length; i++) {
				  const action = this.mixer.clipAction(object.animations[i]);
				  action.play();
				}
			}
    })

    // 创建动画
    this.animation = new PlayerAnimations();
    // 创建孪生体
    if (json.twinConfig){
      this.twin = new PlayerTwin(this.scene,json.twinConfig,this.animation);
    }
    // 创建事件
    this.event = new PlayerEvents(this, this.animation, this.twin);
    this.animation.event = this.event
    this.tweenAnimations();
  }

  tweenAnimations() {
    this.scene?.traverse(object => {
      this.animation.runObjectAnimation(object,false)
    });
  }

}


export { Player };
